var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// SPDX-FileCopyrightText: 2024 Eduardo Robles <edu@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { gql } from "@apollo/client";
export var EXPORT_TEMPLATE = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation ExportTemplate($tenantId: String!) {\n        export_template(tenant_id: $tenantId) {\n            error_msg\n            document_id\n        }\n    }\n"], ["\n    mutation ExportTemplate($tenantId: String!) {\n        export_template(tenant_id: $tenantId) {\n            error_msg\n            document_id\n        }\n    }\n"])));
var templateObject_1;
